module.exports = __webpack_public_path__ + "static/media/matthew-teo.f029e883.jpg";